const TRIGGER_KEYS = [
	{ value: 'welcome_email', label: 'Welcome Email' },
	{ value: 'driver_application_submitted', label: 'Driver Application Submitted' },
	{ value: 'driver_application_denied', label: 'Driver Application Denied' },
	{ value: 'driver_renewal_submitted', label: 'Driver Renewal Submitted' },
	{ value: 'rider_application_submitted', label: 'Rider Application Submitted' },
	{ value: 'super_admin_driver_application', label: 'Super Admin — Driver Application' },
	{ value: 'super_admin_rider_application', label: 'Super Admin — Rider Application' },
	{ value: 'super_admin_pending_drivers_reminder', label: 'Pending Drivers Daily Reminder' },
	{ value: 'document_expiring_one_day', label: 'Document Expiring — 1 Day' },
	{ value: 'document_expiring_two_days', label: 'Document Expiring — 2 Days' },
	{ value: 'document_expiring_three_days', label: 'Document Expiring — 3 Days' },
	{ value: 'document_expiring_one_week', label: 'Document Expiring — 1 Week' },
	{ value: 'document_expiring_two_weeks', label: 'Document Expiring — 2 Weeks' },
	{ value: 'document_expiring_three_weeks', label: 'Document Expiring — 3 Weeks' },
	{ value: 'document_expiring_one_month', label: 'Document Expiring — 1 Month' },
	{ value: 'document_expiring_two_months', label: 'Document Expiring — 2 Months' },
	{ value: 'document_expiring_three_months', label: 'Document Expiring — 3 Months' },
	{ value: 'document_expired', label: 'Document Expired' },
	{ value: 'driver_account_disabled', label: 'Driver Account Disabled' },
];

export default TRIGGER_KEYS;

